import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  setCheckinStatus,
  setCheckinLocation,
  setCheckinTime,
} from "../Redux/Action/checkinAction";
import { Timer } from 'lucide-react';
import styled from 'styled-components';

const Switch = () => {
  const dispatch = useDispatch();
  const checked = useSelector((state) => state.checkin.checkedIn);
  const locationName = useSelector((state) => state.checkin.locationName);
  const checkinTime = useSelector((state) => state.checkin.checkinTime);

  const intervalRef = useRef(null);
  const [seconds, setSeconds] = useState(0);

  const handleToggle = () => {
    const newChecked = !checked;
    dispatch(setCheckinStatus(newChecked));

    if (newChecked) {
      const currentTime = new Date().toLocaleTimeString();
      dispatch(setCheckinTime(currentTime));

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`)
              .then((res) => res.json())
              .then((data) => {
                const { city, town, village, state, country } = data?.address || {};
                const locationString = `${city || town || village || ''}, ${state}, ${country}`;
                dispatch(setCheckinLocation(locationString));
              })
              .catch(() => {
                dispatch(setCheckinLocation("Unknown location"));
              });
          },
          () => {
            alert("Failed to get location.");
          }
        );
      } else {
        alert("Geolocation not supported.");
      }
    } else {
      dispatch(setCheckinLocation(""));
      dispatch(setCheckinTime(""));
    }
  };

  useEffect(() => {
    if (checked) {
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
      setSeconds(0);
    }

    return () => clearInterval(intervalRef.current);
  }, [checked]);

  const formatTime = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  return (
    <StyledWrapper className='flex flex-col sm:flex-row items-start sm:items-center gap-3 p-3 bg-white rounded-lg shadow'>
      {locationName && (
        <div className="text-sm text-gray-700"><span style={{fontSize: "20px"}}>📍</span>: {locationName}</div>
      )}
   {checkinTime && (
  <div className="text-sm text-gray-700 relative group">
    <span style={{fontSize: "20px"}}>⏱️</span>: {checkinTime}
    <span className="tooltiptext absolute bg-gray-800 text-white text-xs p-2 rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
      {formatTime(seconds)}
    </span>
  </div>
)}


      {/* <div className="text-sm font-semibold flex items-center gap-1">
        <Timer size={20} /> {formatTime(seconds)}
      </div> */}
      <div className="flex items-center gap-3">
        {/* <p className="text-xs">{checked ? 'Checked-In' : 'Checked-Out'}</p> */}
        {/* <div className="toggle-wrapper">
          <input
            className="toggle-checkbox"
            type="checkbox"
            checked={checked}
            onChange={handleToggle}
          />
          <div className="toggle-container">
            <div className="toggle-button">
              <div className="toggle-button-circles-container">
                {[...Array(12)].map((_, i) => (
                  <div key={i} className="toggle-button-circle" />
                ))}
              </div>
            </div>
          </div>
        </div> */}
        <span className='label flex items-center text-sm font-medium text-black'>
          Check <span className='pl-1'> {checked ? 'Out' : 'In'} </span>
        </span>
        <label className='autoSaverSwitch relative inline-flex cursor-pointer select-none items-center'>
        <input
          type='checkbox'
          name='autoSaver'
          className='sr-only'
          checked={checked}
          onChange={handleToggle}
        />
        <span
          className={`slider mr-3 flex h-[26px] w-[50px] items-center rounded-full p-1 duration-200 ${
            checked ? 'bg-[#51c15c]' : 'bg-[#EF7320]'
          }`}
        >
          <span
            className={`dot h-[18px] w-[18px] rounded-full bg-white duration-200 ${
              checked ? 'translate-x-6' : ''
            }`}
          ></span>
        </span>
      
      </label>
      </div>
    </StyledWrapper>
  );
};







const StyledWrapper = styled.div`

.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text hidden by default */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 100%; /* Position the tooltip above the text */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

/* Show the tooltip text when the parent is hovered */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.toggle-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: .5em;
  padding: .125em;
  background-image: linear-gradient(to bottom, #d5d5d5, #e8e8e8);
  box-shadow: 0 1px 1px rgb(255 255 255 / .6);
  font-size: 1em;
}

.toggle-checkbox {
  appearance: none;
  position: absolute;
  z-index: 1;
  border-radius: inherit;
  width: 100%;
  height: 100%;
  font: inherit;
  opacity: 0;
  cursor: pointer;
}

.toggle-container {
  display: flex;
  align-items: center;
  position: relative;
  border-radius: .375em;
  width: 3em;
  height: 1.5em;
  background-color: #e8ad0d;
  box-shadow: inset 0 0 .0625em .125em rgb(255 255 255 / .2), inset 0 .0625em .125em rgb(0 0 0 / .4);
  transition: background-color .4s linear;
}

.toggle-checkbox:checked + .toggle-container {
  background-color: #51c15c;
}

.toggle-checkbox:checked .toggle-button {
  background-color: #ed577a;
}

.toggle-button {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: .0625em;
  border-radius: .3125em;
  width: 1.375em;
  height: 1.375em;
  background-color: #e57320;
  box-shadow: inset 0 -.0625em .0625em .125em rgb(0 0 0 / .1), inset 0 -.125em .0625em rgb(0 0 0 / .2), inset 0 .1875em .0625em rgb(255 255 255 / .3), 0 .125em .125em rgb(0 0 0 / .5);
  transition: left .4s;
}

.toggle-checkbox:checked + .toggle-container > .toggle-button {
  left: 1.5625em;
}

.toggle-button-circles-container {
  display: grid;
  grid-template-columns: repeat(3, min-content);
  gap: .125em;
  position: absolute;
  margin: 0 auto;
}

.toggle-button-circle {
  border-radius: 50%;
  width: .125em;
  height: .125em;
  background-image: radial-gradient(circle at 50% 0, #f5f5f5, #c4c4c4);
}
`;

export default Switch;
